import script from "./TransactionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsTable.vue?vue&type=style&index=0&id=b18c26a6&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18c26a6"]])

export default __exports__